// extracted by mini-css-extract-plugin
export default {"privacy":"PrivacyPolicy_privacy__YY-Xb","ss":"PrivacyPolicy_ss__-L2VM"};